import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { News } from 'src/app/models/news.model';
import { NewsService } from 'src/app/services/news.service';
import { ListBaseComponent } from 'src/app/shared/components/list-base/list-base.component';
import { environment } from 'src/environments/environment';
import { ActivityService } from 'src/app/services/activity.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { LookUpService } from 'src/app/services/lookup.service';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

@Component({
    selector: 'app-activity',
    templateUrl: './activity.component.html',
})
export class ActivityComponent extends ListBaseComponent<any> {
    models: any[] = [];
    paginatedModels: any[] = [];
    currentPage = 1;
    itemsPerPage = 10;
    totalItems = 0;
    searchTerm = '';
    maxPageButtons = 5; // Limit the number of page numbers shown to 5
    img: string;
    activityImg: string;
    isLoading: boolean;
    constructor(
        public themeService: ThemeCustomizerService,
        public service: ActivityService,
        public translateService: TranslateService,
        private lookUpService: LookUpService,
        public translationServices: TranslationService


    ) {
        super(translateService, service);
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.lookUpService.getAll$().subscribe(x => {
            this.activityImg = x.find(x => x?.name == "ActivityImg")?.value;
        });
    }
    isToggled = false;



    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {

        this.getData();
    }
    getData() {
        var lang = this.translationServices.getSelectedLanguage();
        var language = 0;
        if (lang == "ar")
            language = 1;
        if (lang == "en")
            language = 2;

        const requestPayload = {
            paginator: {
                page: this.currentPage,
                pageSize: this.itemsPerPage,
                total: this.totalItems,
                pageSizes: []
            },
            searchTerm: this.searchTerm,
            langId: language,
        };

        this.service.getAllPagnation$(requestPayload).subscribe((response: any) => {
            this.models = response.items;
            this.totalItems = response.total;
            this.paginatedModels = this.models;
            this.isLoading = true;

        });
    }
    createImgPath = (serverPath?: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    getHeader_Img(): string | null {
        return localStorage.getItem('News');
    }
    // Handle page change and update API request
    changePage(page: number) {
        this.currentPage = page;
        this.getData();
    }

    // Check if a page number is active
    isPageActive(page: number): boolean {
        return this.currentPage === page;
    }

    // Get the array of page numbers to display (limited to maxPageButtons)
    getPageNumbers(): number[] {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        const startPage = Math.max(1, this.currentPage - Math.floor(this.maxPageButtons / 2));
        const endPage = Math.min(startPage + this.maxPageButtons - 1, totalPages);

        const pages: number[] = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    }

    // Check if 'Previous' button should be disabled
    isPreviousDisabled(): boolean {
        return this.currentPage === 1;
    }

    // Check if 'Next' button should be disabled
    isNextDisabled(): boolean {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        return this.currentPage === totalPages;
    }

    // Move to previous page
    goToPreviousPage() {
        if (this.currentPage > 1) {
            this.changePage(this.currentPage - 1);
        }
    }

    // Move to next page
    goToNextPage() {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        if (this.currentPage < totalPages) {
            this.changePage(this.currentPage + 1);
        }
    }
}

